import React, { useState } from 'react';
import { useScrollAnimation } from '../lib/hooks/useScrollAnimation';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import './Landing.css';

import Hero from '../components/landing/Hero';
import ProblemSection from '../components/landing/ProblemSection';
import WhatThisIs from '../components/landing/WhatThisIs';
import ValuesView from '../components/landing/ValuesView';
import GoalHierarchy from '../components/landing/GoalHierarchy';
import ConnectionsDiagram from '../components/landing/ConnectionsDiagram';
import PracticeMoment from '../components/landing/PracticeMoment';
import PrivacyFoundation from '../components/landing/PrivacyFoundation';
import WaitlistForm from '../components/landing/WaitlistForm';
import CookieBanner from '../components/landing/CookieBanner';
import CookieSettingsModal from '../components/landing/CookieSettingsModal';

export default function Landing() {
  useScrollAnimation();
  const [showCookieModal, setShowCookieModal] = useState(false);

  return (
    <div className="landing">
      <div className="landing__column">
        <LandingNav />
      </div>

      <main id="main">
        <Hero />
        <ProblemSection />
        <WhatThisIs />
        <ValuesView />
        <GoalHierarchy />
        <ConnectionsDiagram />
        <PracticeMoment />
        <PrivacyFoundation />
        <WaitlistForm />
      </main>

      <div className="landing__column">
        <LandingFooter onCookiePreferences={() => setShowCookieModal(true)} />
      </div>

      {/* Cookie consent — rendered last so it layers above content */}
      <CookieBanner onManage={() => setShowCookieModal(true)} />
      <CookieSettingsModal open={showCookieModal} onClose={() => setShowCookieModal(false)} />
    </div>
  );
}
